export const loaders: { [key: string]: React.CSSProperties } = {
    centralLoader: {
        position: 'fixed',
        top: '50%',
        left: 'calc(50% - 200px)',
        transform: 'translate(-50%, -50%)'
    }
}
